export const SuspendUserIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.99935 7.99871C9.84031 7.99871 11.3327 6.50632 11.3327 4.66537C11.3327 2.82442 9.84031 1.33203 7.99935 1.33203C6.1584 1.33203 4.66602 2.82442 4.66602 4.66537C4.66602 6.50632 6.1584 7.99871 7.99935 7.99871Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.27344 14.6667C2.27344 12.0867 4.84011 10 8.00011 10C8.64011 10 9.26012 10.0867 9.84012 10.2467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 11.9987C14.6673 12.212 14.6407 12.4187 14.5873 12.6187C14.5273 12.8854 14.4207 13.1454 14.2807 13.372C13.8207 14.1454 12.974 14.6654 12.0007 14.6654C11.314 14.6654 10.694 14.4054 10.2273 13.9787C10.0273 13.8054 9.85398 13.5987 9.72064 13.372C9.47398 12.972 9.33398 12.4987 9.33398 11.9987C9.33398 11.2787 9.62065 10.6187 10.0873 10.1387C10.574 9.63871 11.254 9.33203 12.0007 9.33203C12.7873 9.33203 13.5007 9.67204 13.9807 10.2187C14.4073 10.692 14.6673 11.3187 14.6673 11.9987Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.686 11.293L11.2793 12.6996"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.293 11.3047L12.7063 12.7113"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
